import script from "./PpeRequestFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PpeRequestFormView.vue?vue&type=script&setup=true&lang=js"

import "./PpeRequestFormView.vue?vue&type=style&index=0&id=5981e096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5981e096"]])

export default __exports__